<template>
  <b-container class="mb-4">
    <h1 class="title text-center">{{ title }}</h1>

    <div
      v-if="isLoading"
      class="loader"
    >
      <b-spinner variant="primary" label="Spinning"></b-spinner>
    </div>

    <b-row v-if="!isLoading" class="justify-content-center mt-4">
      <b-col lg="5" md="5" sm="12" class="cover-img">
        <b-img-lazy
          blank="true"
          blank-color="#bbb"
          :src="menuItem.attributes.image_url"
          alt="Cover"
          thumbnail
          fluid
        ></b-img-lazy>

        <div class="py-3 font-lighter">
          <p class="float-right font-20">$ {{ menuItem.attributes.price }}</p>
          <p class="font-20">{{ menuItem.attributes.name }}</p>
          <p class="text-secondary description">{{ menuItem.attributes.description }}</p>
        </div>
      </b-col>

      <b-col lg="5" md="5" sm="12">
        <h5>Choose Your Preferences</h5>

        <ValidationObserver ref="form" v-slot="{ handleSubmit }">
          <form @submit.prevent="handleSubmit(addToCart)">
            <b-row class="mb-1">
              <b-col cols="5" class="mt-2">
                <label><b>Enter Quantity:</b></label>
              </b-col>

              <b-col cols="7">
                <number-input
                  v-model="quantity"
                  :min="1"
                  inline
                  controls
                ></number-input>
              </b-col>
            </b-row>

            <ValidationProvider
              v-if="menuItem.attributes.option_types.data.length > 0"
              rules="required"
              v-slot="{ failed }"
              v-for="(option_type, index) in menuItem.attributes.option_types.data"
              :key="option_type.id"
            >
              <label class="mb-0 mt-2">
                <b>Choose {{ capitalize(option_type.attributes.name) }}</b>
              </label>

              <span class="form-error">{{ failed ? '1 required' : ''}}</span>

              <b-container>
                <b-row
                  v-for="menu_option in option_type.attributes.menu_options"
                  :key="menu_option.id"
                >
                  <b-col cols="5">
                    <b-form-radio
                      :value="{ option_type_id: option_type.id, menu_option_id: menu_option.id }"
                      v-model="order_item_options[index]"
                    >
                      {{ capitalize(menu_option.name) }}
                    </b-form-radio>
                  </b-col>

                  <b-col>$ {{ menu_option.price }}</b-col>
                </b-row>
              </b-container>
            </ValidationProvider>

            <label v-if="menuItem.attributes.add_ons.data.length > 0" class="mb-0 mt-2">
              <b>Add Ons</b>
            </label>

            <b-container v-if="menuItem.attributes.add_ons.data.length > 0">
              <b-row
                v-for="(add_on, index) in menuItem.attributes.add_ons.data"
                :key="index"
              >
                <b-col cols="5">
                  <b-form-checkbox
                    :value="{ menu_add_on_id: add_on.id }"
                    :name="add_on.attributes.name"
                    v-model="order_item_add_ons[index]"
                  >
                    {{ add_on.attributes.name }}
                  </b-form-checkbox>
                </b-col>

                <b-col cols="7">$ {{ add_on.attributes.price }}</b-col>
              </b-row>
            </b-container>

            <label class="mt-2"><b>Special Instruction</b></label>

            <b-row>
              <b-col class="mb-4">
                <p class="desc-note mb-1">
                  Please let us know if we need to avoid anything or you don't want to add.
                </p>

                <b-form-textarea
                  id="textarea"
                  placeholder="Eg. No mushrooms"
                  v-model="instructions"
                ></b-form-textarea>
              </b-col>
            </b-row>

            <div class="float-right">
              <b-button type="submit" variant="outline-success">Add to Cart</b-button>
            </div>
          </form>
        </ValidationObserver>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  import { getMenuItem } from '../store/api'

  export default {
    name: 'menu-item-show',

    data() {
      return {
        menuItem: null,
        isLoading: true,
        title: 'Menu Item',
        quantity: 1,
        order_item_options: [],
        order_item_add_ons: [],
        instructions: '',
      }
    },

    created() {
      getMenuItem(this.$route.params.id)
        .then(response => {
          this.menuItem = response.data
          this.title = this.menuItem.attributes.name
          this.isLoading = false
        })
    },

    methods: {
      addToCart() {
        this.$store.dispatch("add_to_cart", {
          order_id: $cookies.get('order_id'),
          cart: {
            status: 0,
            order_items_attributes: [{
              menu_item_id: this.menuItem.id,
              quantity: this.quantity,
              instructions: this.instructions,
              order_item_options_attributes: this.order_item_options,
              order_item_add_ons_attributes: this.order_item_add_ons
            }]
          }
        })
        this.quantity = 1
        this.instructions = ''
        this.order_item_options = []
        this.order_item_add_ons = []
        this.$notify({
          type: 'success',
          text: 'Item added in cart successfully'
        })
        this.$router.push({ name: 'menu_items' })
      },
      capitalize(title) {
        return title.charAt(0).toUpperCase() + title.slice(1)
      },
    },

    beforeDestroy() {
      this.quantity = 1
      this.instructions = ''
      this.menuItem = null
      this.order_item_options = []
      this.order_item_add_ons = []
    },
  }
</script>

<style scoped>
  .cover-img img {
    width: 100%;
    height: 246px;
  }
  .img-size img{
    width: 100%;
    height: 120px;
    object-fit: fill;
  }
  .btn-outline-primary {
    color: #5663FF;
    border-color: #5663FF;
    background-color: white;
    box-shadow: none;
  }
  .btn-outline-primary:hover {
    color: white;
    border-color: #5663FF;
    background-color: #5663FF;
  }
  .form-error {
    color: #D9534F;
    padding: 5px;
  }
  .font-20 {
    font-size: 20px;
  }
  .description {
    height: fit-content;
    text-align: justify;
  }
</style>
